var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reporting-section" },
    [
      _c("div", { staticClass: "section-header" }, [
        _c("i", { staticClass: "material-icons section-icon" }, [
          _vm._v("thumb_up"),
        ]),
        _c("h2", [
          _vm._v(_vm._s(_vm.$t("dash.reporting.section.engagements.title"))),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "metric-row" },
        [
          _c("MetricCard", {
            attrs: {
              value: _vm.effectiveTotalEngagement,
              "previous-value": _vm.prev("totalEngagement"),
              label: _vm.$t("dash.reporting.interactions"),
              icon: "fa-solid fa-hand-point-up",
            },
          }),
          _c("MetricCard", {
            attrs: {
              value: _vm.effectiveTotalReactions,
              "previous-value": _vm.prev("totalReactions"),
              label: _vm.$t("dash.reporting.reaction"),
              icon: "thumb_up",
            },
          }),
          _c("MetricCard", {
            attrs: {
              value: _vm.effectiveTotalComments,
              "previous-value": _vm.prev("totalComments"),
              label: _vm.$t("dash.reporting.comment"),
              icon: "chat_bubble",
            },
          }),
          _c("MetricCard", {
            attrs: {
              value: _vm.effectiveTotalShares,
              "previous-value": _vm.prev("totalShares"),
              label: _vm.$t("dash.reporting.share"),
              icon: "share",
            },
          }),
          _vm.stats.page.totalClicks != null
            ? _c("MetricCard", {
                attrs: {
                  value: _vm.stats.page.totalClicks || 0,
                  "previous-value": _vm.prev("totalClicks"),
                  label: _vm.$t("dash.reporting.clic"),
                  icon: "touch_app",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      (
        _vm.network === "linkedin"
          ? _vm.liEngagementData.length && _vm.liEngagementLabels.length
          : _vm.engagementData.length && _vm.graphLabels.length
      )
        ? _c(
            "div",
            { staticClass: "graph-wrap" },
            [
              _c("Graph", {
                attrs: {
                  id: `engagement-${_vm.graphId}`,
                  data:
                    _vm.network === "linkedin"
                      ? _vm.liEngagementData
                      : _vm.engagementData,
                  labels:
                    _vm.network === "linkedin"
                      ? _vm.liEngagementLabels
                      : _vm.graphLabels,
                  height: "220px",
                  width: "100%",
                  "per-point-order": true,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.reactionBreakdown
        ? [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "reactions-breakdown" },
              _vm._l(_vm.reactionBreakdown, function (r) {
                return r.value > 0
                  ? _c("div", { key: r.key, staticClass: "reaction-item" }, [
                      _c("span", { staticClass: "reaction-emoji" }, [
                        _vm._v(_vm._s(r.emoji)),
                      ]),
                      _c("div", { staticClass: "reaction-bar-wrap" }, [
                        _c("div", {
                          staticClass: "reaction-bar",
                          style: { width: r.pct + "%", background: r.color },
                        }),
                      ]),
                      _c("span", { staticClass: "reaction-count" }, [
                        _vm._v(_vm._s(_vm.fmtNum(r.value))),
                      ]),
                      _c("span", { staticClass: "reaction-pct" }, [
                        _vm._v(_vm._s(r.pct) + "%"),
                      ]),
                    ])
                  : _vm._e()
              }),
              0
            ),
          ]
        : _vm._e(),
      _vm.calendarData
        ? [
            _c("div", { staticClass: "subsection-header" }, [
              _c("i", { staticClass: "material-icons subsection-icon" }, [
                _vm._v("schedule"),
              ]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("dash.reporting.optimal_times")) +
                    " en fonction des "
                ),
                _c("span", { staticClass: "heatmap-select-wrap" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.calendarMetric,
                          expression: "calendarMetric",
                        },
                      ],
                      staticClass: "heatmap-select",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.calendarMetric = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    _vm._l(_vm.calendarMetrics, function (m) {
                      return _c(
                        "option",
                        { key: m.key, domProps: { value: m.key } },
                        [_vm._v(_vm._s(m.label))]
                      )
                    }),
                    0
                  ),
                  _c(
                    "i",
                    { staticClass: "material-icons heatmap-select-arrow" },
                    [_vm._v("arrow_drop_down")]
                  ),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "calendar-wrap" },
              [
                _c("GraphCalendar", {
                  key: _vm.calendarMetric,
                  attrs: {
                    id: `calendar-${_vm.graphId}-${_vm.calendarMetric}`,
                    data: _vm.calendarData,
                    "optimal-times": _vm.stats.page.optimalTimes,
                    "day-labels": _vm.weekDayLabels,
                    "unit-label": _vm.calendarMetricLabel,
                    "is-percent": _vm.calendarMetric === "engagement",
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "subsection-header" }, [
      _c("i", { staticClass: "material-icons subsection-icon" }, [
        _vm._v("mood"),
      ]),
      _c("span", [_vm._v("Réactions détaillées")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }